/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/passkey`,
    // @ts-ignore for sm-axios
    urlTemplate: '/passkey',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Adds passkey information for the user
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    /**
     * The token of the user to add the passkey for.
     */
    token: string
  }
}

export interface Response {
  code: 'PasskeyCreated' | 'Auth0AuthenticationMethodsNotFound'
  /**
   * id of the created authx passkey record; present when code is PasskeyCreated.
   */
  passkeyId?: string
}

